import React, {Component} from "react";
import Product from "./product";
import Filter from "./filter";
import BrandFilter from "./brandFilter";

import PaginationLocale from 'rc-pagination/lib/locale/en_US';
import Pagination from 'rc-pagination';

import Slider from 'rc-slider';
const Range = Slider.Range;

import Checkbox from 'rc-checkbox';

import DisplayFormikState from "../helpers/displayFormikState";
import {Dump} from "../helpers/dump";

import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch'

const perpage = 6;

class ProductListing extends Component {
	constructor(props) {
		super(props);

		this.state = {
			opened: (window.innerWidth >= 1870) ? true : false,
			sortBy: 'default',
			currentPage: 1,
			filters: {},
			prices: {
				min: null,
				max: null,
				selectedMin: null,
				selectedMax: null
			},

			atributes: [],
			brands: {},
			products: [],
			filteredProducts: [],
			shownProducts: []
		};

		this.onPageChange = this.onPageChange.bind(this);
		this.onSortChange = this.onSortChange.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);
		this.onPriceSliderChange = this.onPriceSliderChange.bind(this);
		this.onFiltersButtonClick = this.onFiltersButtonClick.bind(this);
	}

	decodeHtmlEntities(str) {
		return str.replace(/&#(\d+);/g, function(match, dec) {
			return String.fromCharCode(dec);
		});
	}

	onPriceSliderChange(range) {
		//console.log(range);
		let prices = this.state.prices;
		prices.selectedMin = range[0];
		prices.selectedMax = range[1];

		let filteredProducts = this.applyFilters();
		this.setState({
			prices: prices,
			currentPage: 1,
			filteredProducts: filteredProducts,
			shownProducts: this.applyPagination(filteredProducts, 1)
		});
	}

	onSortChange(e) {
		this.setState({
			sortBy: e.target.value,
			shownProducts: this.applyPagination(this.state.filteredProducts, this.state.currentPage, e.target.value)
		});
	}

	onFiltersButtonClick(e) {
		e.preventDefault();

		this.setState({
			opened: !this.state.opened
		});
	}

	onPageChange(page) {
		this.setState({
			currentPage: page,
		});
		this.setState({
			shownProducts: this.applyPagination(this.state.filteredProducts, page)
		});
	}

	onCheckboxChange(e, attributeId, element) {
		if (e.target.checked === true) {
			this.addFilter(attributeId, element);
		} else {
			this.removeFilter(attributeId, element);
		}

		let filteredProducts = this.applyFilters();
		this.setState({
			filteredProducts: filteredProducts,
			shownProducts: this.applyPagination(filteredProducts, 1)
		});
	}

	addFilter(attributeId, value) {
		let filters = this.state.filters;

		if (filters.hasOwnProperty(attributeId) === false) {
			filters[attributeId] = [value];
		} else {
			filters[attributeId].push(value);
		}

		this.setState({
			filters: filters,
			currentPage: 1
		});
	}

	removeFilter(attributeId, value) {
		let filters = this.state.filters;

		if (filters.hasOwnProperty(attributeId) === true) {
			let index = filters[attributeId].indexOf(value);

			if (index > -1) {
				filters[attributeId].splice(index, 1);
			}
		}

		if (filters[attributeId].length === 0) {
			delete filters[attributeId];
		}

		this.setState({
			filters: filters,
			currentPage: 1
		});
	}

	applyPagination(products, page, sort) {
		let productsToReturn = [];
		let productsCopy = products.slice();

		let sortBy = this.state.sortBy;
		if ((typeof(sort) !== 'undefined') && (sort !== null)) {
			sortBy = sort;
		}
		//console.log('sortBy: ' + sortBy);

		switch (sortBy) {
			case "name":
				productsCopy.sort((a, b) => {
					if (a.name < b.name) { return -1; }
					if (a.name > b.name) {return 1; }
					return 0;
				});
				break

			case "priceAsc":
				productsCopy.sort((a, b) => {
					if (a.price < b.price) { return -1; }
					if (a.price > b.price) { return 1; }
					return 0;
				});
				break

			case "priceDesc":
				productsCopy.sort((a, b) => {
					if (a.price > b.price) { return -1; }
					if (a.price < b.price) { return 1; }
					return 0;
				});
				break

			case "weight":
				productsCopy.sort((a, b) => {
					if (a.weight < b.weight) { return -1; }
					if (a.weight > b.weight) { return 1; }
					return 0;
				});
				break

		}
		//console.log(productsCopy);

		if (page) {
			let offset = ((page - 1) * perpage);
			productsToReturn = productsCopy.splice(offset, perpage);
		} else {
			productsToReturn = productsCopy;
		}

		//console.log('perpage: ' + perpage);
		//console.log('currentPage: ' + this.state.currentPage);
		//console.log('page: ' + page);
		//console.log('offset: ' + offset);

		return productsToReturn;
	}

	applyFilters() {
		let productsToReturn = [];

		this.state.products.map(product => {
			let isShown = true;

			if (product.price < this.state.prices.selectedMin || product.price > this.state.prices.selectedMax) {
				isShown = false;
			}

			for (let filterId in this.state.filters) {
				if (filterId === 'brand') {
					let found = false;

					for (let z = 0; z < this.state.filters[filterId].length; z++) {
						let filterValue = this.state.filters[filterId][z];

						if (product.brand === filterValue) {
							found = true;
						}
					}

					if (found === false) {
						isShown = false;
					}
				} else {
					filterId = parseInt(filterId);
					//console.log(this.state.filters[filterId]);

					let found = false;

					for (let z = 0; z < this.state.filters[filterId].length; z++) {
						let filterValue = this.state.filters[filterId][z];

						if (typeof product.attributes[filterId] !== 'undefined') {
							let search = product.attributes[filterId].find(attributeEntry => {
								//console.log(attributeEntry);
								return attributeEntry.value === filterValue;
							});
							//console.log(search);
							if (typeof search === 'object') {
								found = true;
							}
						}
					}

					if (found === false) {
						isShown = false;
					}
					//console.log(product.attributes[filterId].indexOf(this.state.filters[filterId]));
				}
			}

			if (isShown === true) {
				productsToReturn.push(product);
			}
		})

		return productsToReturn;
	}

	isEmptyObject(obj) {
		return (Object.keys(obj).length === 0 && obj.constructor === Object);
	}

	render() {
		let range = '';

		if (this.state.prices.min !== null && this.state.prices.max !== null) {
			range = (
				<div>
					<Range
						allowCross={false}
						min={this.state.prices.min}
						max={this.state.prices.max}
						value={[this.state.prices.selectedMin, this.state.prices.selectedMax]}
						onChange={this.onPriceSliderChange}
					/>
					Min: <span>{this.state.prices.selectedMin}</span>&nbsp;
					Max: <span>{this.state.prices.selectedMax}</span>
				</div>
			);
		}

		let brand = '';
		if (this.isEmptyObject(this.state.brands) === false) {
			brand = (<BrandFilter brands={this.state.brands} onCheckboxChange={this.onCheckboxChange} />);
		}

		return (
			<div className="clearFix textCenter">
				<div className="sortBy">
					Sort by&nbsp;
					<select name="typeId" defaultValue="default" onChange={this.onSortChange}>
						<option value="default">default</option>
						<option value="name">name</option>
						<option value="priceAsc">price ascending</option>
						<option value="priceDesc">price descending</option>
						{/*<option value="weight">weight</option>*/}
					</select>
					{/*<Dump value={this.state.sortBy}/>*/}
				</div>
				<div className="leftSpacer"></div>

				<div className="breadCrumbsStyled">
					<div dangerouslySetInnerHTML={{__html: this.props.breadcrumbs}}></div>
					<h2>{this.props.name}</h2>
				</div>

				<div className={this.state.opened ? 'filters' : 'filters closed'}>
					<a href="#" className="filtersClose" onClick={this.onFiltersButtonClick}></a>

					<div className="filter">
						<h6>Price</h6>
						{range}
					</div>

					{brand}

					{this.state.atributes.map(attribute => {
						if (typeof attribute.values !== 'undefined') {
							return (<Filter key={attribute.name} attribute={attribute} onCheckboxChange={this.onCheckboxChange} />);
						}

						return "";
					})}
				</div>

				{/*<Dump value={this.state.filters}/>*/}
				{/*<Dump value={this.state.brands}/>*/}

				<article className="productsGrid row with three columns">
					{this.state.shownProducts.map(product => {
						return (<Product value={product} key={product.id} />);
					})}
				</article>

				<br/>

				<Pagination
					onChange={this.onPageChange}
					pageSize={perpage}
					defaultCurrent={1}
					current={this.state.currentPage}
					total={this.state.filteredProducts.length}
					showTotal={(total) => `Total ${total} items`}
					locale={PaginationLocale}
				/>

				{/*<Dump value={this.state.filteredProducts}/>*/}
			</div>
		);
	}

	componentDidMount() {
		let id = this.props.id;

		function getAll() {
			function getProducts() {
				return fetch('/api/products/' + id).then(result => result.json());
			}

			function getAttributes() {
				return fetch('/api/attribute').then(result => result.json());
			}

			return Promise.all([getProducts(), getAttributes()])
		}

		function getIndexOfValue(array, id) {
			let object = array.find((element) => {
				return element.id === id;
			});

			return array.indexOf(object);
		}

		getAll().then(([products, attributes]) => {
			attributes = attributes.filter(attribute => {
				return attribute.filterable;
			})

			let brands = {};
			let min = Infinity;
			let max = 0;

			for (let i = 0; i < products.length; i++) {
				let product = products[i];
				let price = product.price;

				if (price < min) {
					min = price;
				}

				if (price > max) {
					max = price;
				}

				if (product.brand != "") {
					if (brands.hasOwnProperty(product.brand)) {
						brands[product.brand]++;
					} else {
						brands[product.brand] = 1;
					}
				}

				for (let attributeId in product.attributes) {
					attributeId = parseInt(attributeId);
					let productAttributes = product.attributes[attributeId];
					let attributeIndex = getIndexOfValue(attributes, attributeId);

					if (attributeIndex > -1) {
						if (typeof attributes[attributeIndex].values == 'undefined') {
							attributes[attributeIndex].values = {};
						}

						for (let z = 0; z < productAttributes.length; z++) {
							let value = productAttributes[z].value;
							if (attributes[attributeIndex].values.hasOwnProperty(value)) {
								attributes[attributeIndex].values[value]++;
							} else {
								attributes[attributeIndex].values[value] = 1;
							}
						}
					}
				}
			}

			this.setState({
				atributes: attributes,
				products: products,
				brands: brands,
				prices: {
					min: Math.floor(min),
					max: Math.ceil(max),
					selectedMin: Math.floor(min),
					selectedMax: Math.ceil(max)
				}
			});

			let filteredProducts = this.applyFilters();
			this.setState({
				filteredProducts: filteredProducts
			});

			this.setState({
				shownProducts: this.applyPagination(filteredProducts, 1)
			});
		});
	}
}

export default ProductListing;